module.exports = __webpack_public_path__ + "img/svg/avatar.44d17a3bbd8b938a5029b2f0595a6785.svg";